<template>
    <div class="main-container-l">
        <div class="loading-container" v-if="loading"><img src="../../assets/img/loading.svg"></div>
        <div class="results-menu-l" v-if="isMobile">
            <router-link v-if="showHorsesOfferButton" class="button button-mobileLoto mbutton-results-lotto full" :to="{ path: '/web/horses/' }">{{$t('VHORSES')}}</router-link>
            <ResultsPageRoutes v-on:toggleCalendar="toggleCalendar" v-bind:showCalendar="showCalendar" />
            <Calendar v-show="showCalendar" :otherStartDate="startDate" v-on:selectDate="changeDate"></Calendar>
        </div>
        <div class="offer-container-l">
            <div class="group-offer-l horses" v-if="!isMobile">
                <ResultsPageRoutes
                v-if="!isMobile"
                v-on:toggleCalendar="toggleCalendar"
                v-bind:showCalendar="showCalendar"
                />
                <div :settings="{wheelPropagation:true}" class="group-game group-game-horse-res">
                    <div class="ggame-heading">
                        <span class="ggame-heading-icon sport-icon"><img src="../../assets/img/horse-icon.svg"></span>
                        <h2 class="ggame-heading-text">{{$t('FLEXVIRTUALHORSERACING')}}</h2>
                    </div>
                    <template v-if="races.length > 0">
                        <div class="ggame-item horse-res" v-for="race in races" :key="race.raceInstanceId">
                            <div class="ggame-content" v-on:click="selectRace(race)">
                                <div class="ggame-item-text horse">
                                    <span class="date-time">{{race.dateTime | getLocalDate}}</span>
                                    <span class="race-number">{{$t('RACENUMBER')}}: {{race.dailyInstanceId}}</span>
                                    <span :class="(selectedRace == race) ? 'arrow-up' : 'arrow-down'"></span></div>
                            </div>
                            <template v-if="selectedRace == race">
                                <div class="ggame-horse-results-container">
                                    <div class="ggame-horse-results" v-for="horse in race.raceHorses" :key="horse.startingPosition">
                                        <img :src="'/static/horses/horse-'+prependZeros(horse.startingPosition, 2)+'.svg'" class="horse-number">
                                        <div class="ggame-horsename" v-html="horse.name"></div>
                                </div>
                                </div>
                            </template>
                        </div>
                    </template>
                    <div v-if="!races.length && !loading" class="group-game empty">
                        <div class="error-offer-loading">
                            <img class="odd-stats-img" src="../../assets/img/error-offer-loading.svg" alt="">
                            <p>{{$t('NOVHORSERESULTSFORTHISFILTER')}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="" v-if="isMobile">
            <div class="group-offer-l horses">

                <div :settings="{wheelPropagation:true}" class="group-game group-game-horse-res">
                    <div class="ggame-heading">
                        <span class="ggame-heading-icon sport-icon"><img src="../../assets/img/horse-icon.svg"></span>
                        <h2 class="ggame-heading-text">{{$t('FLEXVIRTUALHORSERACING')}}</h2>
                    </div>
                    <template v-if="races.length > 0">
                        <div class="ggame-item horse-res" v-for="race in races" :key="race.raceInstanceId">
                            <div class="ggame-content" v-on:click="selectRace(race)">
                                <div class="ggame-item-text horse">
                                    <span class="date-time">{{race.dateTime | getLocalDate}}</span>
                                    <span class="race-number">{{$t('RACENUMBER')}}: {{race.dailyInstanceId}}</span>
                                    <span :class="(selectedRace == race) ? 'arrow-up' : 'arrow-down'"></span></div>
                            </div>
                            <template v-if="selectedRace == race">
                            <div class="ggame-horse-results-container">
                                <div class="ggame-horse-results" v-for="horse in race.raceHorses" :key="horse.startingPosition">
                                    <img :src="'/static/horses/horse-'+prependZeros(horse.startingPosition, 2)+'.svg'" class="horse-number">
                                    <div class="ggame-horsename" v-html="horse.name"></div>
                                </div>
                            </div>
                            </template>
                        </div>
                    </template>
                    <div v-if="!races.length && !loading" class="group-game empty">
                        <div class="error-offer-loading">
                            <img class="odd-stats-img" src="../../assets/img/error-offer-loading.svg" alt="">
                            <p>{{$t('NOVHORSERESULTSFORTHISFILTER')}}</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="results-menu-l lotto-results-desktop" v-if="!isMobile">
            <div class="results-menu-subcontainer">
                <Calendar :otherStartDate="startDate" v-on:selectDate="changeDate"></Calendar>
            </div>
        </div>
        <!-- div class="results-menu-l" v-if="!isMobile">
            <div class="results-menu-subcontainer">
               <Calendar :otherStartDate="startDate" v-on:selectDate="changeDate"></Calendar>
            </div>
        </div -->
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';

import moment from 'moment-timezone';
import { Common } from '@om-retail/vue-common';
import Calendar from '../components/Calendar.vue';
import ResultsPageRoutes from './containers/ResultsPageRoutes.vue';

export default {
    name: 'HorseResults',
    components:
    {
        Calendar,
        ResultsPageRoutes,
    },
    data()
    {
        return {
            races: [],
            selectedRace: null,
            loading: true,
            showCalendar: false,
            startDate: moment().set({ hours: 0, minutes: 0, seconds: 0 }),
            endDate: moment().add(1, 'day').set({ hours: 0, minutes: 0, seconds: 0 }),
        };
    },
    created()
    {
        const me = this;
        me.selectDate({ setDefaults: true, results: true });

        me.getOfferByDate();
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'isMobile',
            'offerHandling',
        ]),
        showHorsesOfferButton()
        {
            const me = this;

            if (me.globals
            && me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website
            && me.globals.publicConfig.website.extraButtonOptions
            && me.globals.publicConfig.website.extraButtonOptions.displayHorsesOfferButtonOnResults)
            {
                return true;
            }

            return false;
        },
    },
    watch:
    {
        startDate(val)
        {
            const me = this;
            if (val === false)
            {
                return;
            }

            me.getOfferByDate();
        },
    },
    methods:
    {
        ...mapActions([
            'selectDate',
        ]),
        selectRace(race)
        {
            const me = this;

            if (me.selectedRace === race)
            {
                me.selectedRace = null;
            }
            else
            {
                me.selectedRace = race;
            }
        },
        changeDate(val)
        {
            const me = this;
            me.startDate = val;
        },
        prependZeros(pos, num)
        {
            return Common.prependZeros(pos, num);
        },
        toggleCalendar()
        {
            const me = this;
            me.showCalendar = !me.showCalendar;
        },
        async getOfferByDate()
        {
            const me = this;

            if (me.startDate === false)
            {
                return;
            }

            me.loading = true;

            let startDate = moment(me.startDate).set({ hours: 0, minutes: 0, seconds: 0 });
            startDate = moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss');

            let endDate = moment(me.startDate).add(1, 'day').set({ hours: 0, minutes: 0, seconds: 0 });
            endDate = moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss');

            const params = {
                type: 'finished',
                minoffer: true,
                limit: 1000,
                startDate,
                endDate,
            };

            const data = await me.offerHandling.callOffer('/vhorse/getOffer', params);

            me.races = [];

            const races = data.data;

            for (const race of races)
            {
                race.raceHorses.sort((a, b) =>
                {
                    if (a.finishPosition > b.finishPosition)
                    {
                        return 1;
                    }
                    return -1;
                });
                me.races.push(race);
            }

            me.loading = false;
        },
    },
};
</script>
